











































import { defineComponent, useFetch, ref, useContext, onMounted,
  computed, useMeta } from '@nuxtjs/composition-api';
import SvgImage from '~/components/General/SvgImage.vue';
import HeadlessTwoColBanner from '~/components/Headless/TwoColBanner.vue';
import CategoryWatermark from '~/components/Headless/Watermarks/CategoryWatermark.vue';
import CircleGradient from '~/components/Headless/Watermarks/CircleGradient.vue';
import HeadlessGallery from '~/components/Headless/Gallery.vue';
import type { MetaInfo } from 'vue-meta';
import HTMLContent from '~/components/HTMLContent.vue';
import PrimaryButton  from '~/components/Headless/PrimaryButton.vue';
import { setSirvImage } from '~/helpers/headless/helpers';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';

export default defineComponent({
  components: {
    SvgImage, HeadlessTwoColBanner, CategoryWatermark, CircleGradient, HeadlessGallery, HTMLContent, PrimaryButton, NewProducts: () => import(/* webpackPrefetch: true */ '~/components/NewProducts.vue')
  },
  setup(props, ctx) {
    const pageData = ref(null);
    const metaTitle = ref('Something went wrong!');
    const pageDataGalleryArray = ref(null);
    const bannerImagesArray = ref(null);
    const { addTags } = useCache();
    const { route, $strapi } = useContext();
    const qs = require('qs');
    const query = qs.stringify({
      populate: [
        'Banner',
        'Banner.media',
        'Banner.Images',
        'gallery.media'
      ],
    }, {
      encodeValuesOnly: true, // prettify URL
    });

    useFetch(async () => {
      // TO DO use strapi / right now $http.get is not working correctly
      const { data } = await $strapi.find('cms-pages?filters[slug][$eq]=' + route.value.path.slice(1) + '&' + query);
      if (!data.length) return;
      pageData.value = data[0].attributes;
      metaTitle.value = data[0].attributes.title;
      pageDataGalleryArray.value = pageData.value.gallery?.data?.map(item => {return {url: setSirvImage(item.attributes.url, 300), alt: item.attributes.alt}});
      bannerImagesArray.value = pageData.value.Banner?.Images?.data?.map(item => {return setSirvImage(item.attributes.url, 300)});

      addTags([{ prefix: CacheTagPrefix.View, value: route.value.path.slice(1) }]);
    });
    const routePath = route.value.path;

    return { pageData, metaTitle, pageDataGalleryArray, bannerImagesArray, routePath }
  },
  head() : MetaInfo {
    return {
      title: this.metaTitle + ' | Hedge Rose'
    }
  },
})
